// ABOUTME: Relation portal orders tab view for Amazon FBA replenishments.
// ABOUTME: Mirrors OutboundBolView (relation Bol.jsx) with the Amazon FBA data source, states, and card.
import AddIcon from '@mui/icons-material/Add';
import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";
import Text from "../../../../components/theme/text/Text";
import { tokens } from '../../../../theme';

import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";

import { useEffect, useState } from "react";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShCopyButton from '../../../../components/theme/ShCopy';
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";

import { useRef } from "react";
import { AMAZON_FILTER_KEYS } from '../../../../components/global/DataGrid/Filter';
import MpAddAmazonReplenishment from '../../../../components/global/ModalsProgression/MpAddAmazonReplenishment/MpAddAmazonReplenishment';
import MConfirmAmazonPlacement from '../../../../components/global/Modals/MConfirmAmazonPlacement';
import { useFindAllAmazonreplenishmentsQuery } from '../../../../newapi/webshop/amazonreplenishmentSlice';
import ShDoubleTextSkeleton from '../../../../components/theme/skeleton/ShDoubleTextSkeleton';
import { getAmazonReplenishmentStateData } from "../../../../utils/labelColorText";
import { AmazonFbaRelationCard } from '../../../../components/global/cards/orders/AmazonFbaCard';
import { calculateBusinessDays, getDaysColorVariant } from '../../../warehouse/outbound/orders/views/Bol';
import ShDataGrid3 from '../../../../components/theme/datagrid3/ShDataGrid3';
import { RELATION_ORDERS_AMAZONFBA } from '../family';
import SidepanelLoader from '../../../../components/theme/sidepanel2/SidepanelLoader';

const SpAmazonReplenishmentDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpAmazonReplenishmentDetails/SpAmazonReplenishmentDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1}>
            <ButtonGroup version={2}>
                <Shbutton className={"group-btn"} color={theme.palette.mode === "dark" ? "blue" : "primary"} endIcon={<AddIcon/>} variant="contained" onClick={() => props.setOpen(true)}>{t("new_replenishment")}</Shbutton>
            </ButtonGroup>
        </Box>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    filter: [AMAZON_FILTER_KEYS.STATE],
};

const OutboundAmazonFbaView = (props) => {
    const { t, i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const [isExtended, setIsExtended] = useState(false);
    const [spLoading, setSpLoading] = useState();

    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);

    const [placementOpen, setPlacementOpen] = useState(false);
    const [placementReplenishmentId, setPlacementReplenishmentId] = useState();
    const handlePlacementClose = () => setPlacementOpen(false);
    const handleCreated = (headerId) => {
        if (!headerId) return;
        setPlacementReplenishmentId(headerId);
        setPlacementOpen(true);
    };

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions setOpen={setOpen}></GridActions>,
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[]);

    const [itemId, setItemId] = useState();
    const itemIdRef = useRef(itemId);

    const getReplenishmentDetails = (params) => {
        if (!params) return;

        const newItemId = parseInt(params.row.id);
        // Only update state if the itemId has actually changed
        if (itemIdRef.current !== newItemId) {
            if(!spLoading) {
                setSpLoading(true);
            }
            setItemId(newItemId);
            itemIdRef.current = newItemId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {field: "reference", headerName: t("reference"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Text noBreak>{params.row.reference}</Text>
                        <ShCopyButton
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}}
                            sx={{position:"absolute",right:0,zIndex:3000}}
                            className={"copyel"}
                            closeAfter={1500}
                            value={params.row.reference}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {
            field: "state",
            headerName: t("status"),
            flex:1,
            filter: AMAZON_FILTER_KEYS.STATE,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }

                const { labelcolor, labeltext } = getAmazonReplenishmentStateData(params.row.state, theme);

                // Show business days counter only for "open" state
                if(params.row.state === "open") {
                    const businessDays = calculateBusinessDays(params.row.createdAt);
                    const colorVariant = getDaysColorVariant(businessDays);

                    return (
                        <>
                            <ShLabel size={32} palette="normal" variant={labelcolor}>{t(labeltext)}</ShLabel>
                            <ShLabel size={32} palette="normal" sx={{ml:2}} fitted variant={colorVariant}>+ {businessDays}</ShLabel>
                        </>
                    )
                }

                return <ShLabel size={32} palette="normal" variant={labelcolor}>{t(labeltext)}</ShLabel>;
              }
        },
        {field: "webshopcredentials", headerName: t("channel_name"),flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (<Text>{params.row.webshopcredentials?.description ?? t("self_created")}</Text>)
            }
        },
        {field: "amountOfLines", headerName: t("lines_count"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }
                return (
                    <Box display="flex"  flexDirection="column" gap={1}>
                        <Text>{params.row.amountOfLines} {t("products")}</Text>
                        <Text>{params.row.amountOfItems} {t("items")}</Text>
                    </Box>
                );
            }
        },
        {
            field: "createdAt",
            headerName: t("date_created"),
            flex:1,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                return new Date(params.row.createdAt).toLocaleString(i18n.language, {
                    dateStyle: 'short',
                    timeStyle: 'short'
                });
              }
        },
        {
            field: "phoneView",
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <AmazonFbaRelationCard onClick={() => getReplenishmentDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}  />
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            <ShDataGrid3
                key={theme.palette.mode}
                gridKey={RELATION_ORDERS_AMAZONFBA.AMAZONFBA.gridKey}
                content={useFindAllAmazonreplenishmentsQuery}
                gridActions={<GridActions setOpen={setOpen}></GridActions>}
                title={t('action_required') }
                gridOptions={gridOptions}
                sortModel={{field: columns[4].field,type:"ASC"}}
                columns={columns}
                onRowClick={getReplenishmentDetails}
            >

            </ShDataGrid3>

            {spLoading &&
                <SpAmazonReplenishmentDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    itemId={itemId}
                />
            }

            <MpAddAmazonReplenishment open={open} handleClose={handleClose} onCreated={handleCreated}/>

            <MConfirmAmazonPlacement
                open={placementOpen}
                handleClose={handlePlacementClose}
                replenishmentId={placementReplenishmentId}
            />
        </Box>
    );
}
export default OutboundAmazonFbaView;
